




import { Component, Vue } from 'vue-property-decorator';
import Intro from '@/components/Intro.vue';
import store from '../store';

@Component({
	components: {
		Intro,
	},
})
export default class Home extends Vue {}
